import { render, staticRenderFns } from "./POReleased.vue?vue&type=template&id=10af0703&"
import script from "./POReleased.vue?vue&type=script&lang=js&"
export * from "./POReleased.vue?vue&type=script&lang=js&"
import style0 from "./POReleased.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports